import { render } from "./or-main-page-content.vue?vue&type=template&id=9a4ff344&scoped=true&bindings={\"settings\":\"props\",\"feedback_settings\":\"data\"}"
import script from "./or-main-page-content.vue?vue&type=script&lang=js"
export * from "./or-main-page-content.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9a4ff344"

export default script